// import { fetch } from './utils';
// import { getCountryEvents } from './countryEvents';

// export const getCountries = getCountryEvents;

import appData from '../assets/data/country-events.json';


const appDataPromise = Promise.resolve(appData);

export function getCountries () {
  return appDataPromise;
}



// export function getCountries ({ includeEvents = false } = {}) {
//   if (includeEvents) {
//     return Promise.all([countriesPromise, getCountryEvents()])
//       .then(([countries, countryEvents]) => {
//         return Object.keys(countryEvents).reduce((countryData, countryId) => {
//           countryData[countryId] = {
//             ...countries[countryId],
//             ...countryEvents[countryId]
//           };

//           return countryData;
//         }, {});
//       });
//   }

//   return countriesPromise;
// }

// const countriesPromise = fetch('/assets/countries.txt')
// .then(data => {
//   const countries = {};

//   data.trim().split('\n').forEach(line => {
//     const id = line.slice(0,2).toLowerCase();
//     const name = line.slice(3);

//     countries[id] = {
//       name
//     };
//   });

//   return countries;
// });



// WEBPACK FOOTER //
// ./lib/countries.js